import {
	dateRange,
	isTripWorkspace,
	type TripWorkspace,
	type TripDay,
} from "./trip";
const checked = (trip: TripWorkspace) => {
	if (!isTripWorkspace(trip)) throw new Error("INVALID_TRIP_WORKSPACE");
	return trip;
};
export function swapTripDays(
	trip: TripWorkspace,
	first: string,
	second: string,
) {
	const copy = structuredClone(trip);
	const a = copy.days.find((d) => d.date === first),
		b = copy.days.find((d) => d.date === second);
	if (!a || !b) throw new Error("INVALID_TRIP_DAY");
	[a.items, b.items] = [b.items, a.items];
	copy.filmMoments?.forEach((m) => {
		if (m.dayDate === first) m.dayDate = second;
		else if (m.dayDate === second) m.dayDate = first;
	});
	copy.lastAdjustment = null;
	copy.lastReplacement = null;
	return checked(copy);
}
export function resizeTripDates(
	trip: TripWorkspace,
	start: string,
	end: string,
) {
	const dates = dateRange(start, end),
		copy = structuredClone(trip);
	copy.startDate = start;
	copy.endDate = end;
	copy.days = dates.map((date, i) => ({
		date,
		items: copy.days[i]?.items ?? [],
	}));
	const overflow = trip.days
		.slice(dates.length)
		.flatMap((d) => structuredClone(d.items));
	copy.candidates = [...(copy.candidates ?? []), ...overflow].filter(
		(p, i, a) => a.findIndex((x) => x.id === p.id) === i,
	);
	copy.filmMoments = copy.filmMoments?.map((m) => {
		const index = trip.days.findIndex((d) => d.date === m.dayDate);
		return {
			...m,
			dayDate: dates[Math.min(index, dates.length - 1)]!,
			planItemId: index >= dates.length ? null : m.planItemId,
		};
	});
	copy.lastAdjustment = null;
	copy.lastReplacement = null;
	return checked(copy);
}
export function dayWorkload(trip: TripWorkspace, day: TripDay) {
	const items = day.items.filter((i) => !i.deferred);
	const unknown = items.filter((i) => i.stayMinutes === undefined).length;
	const minutes =
		items.reduce((n, i) => n + (i.stayMinutes ?? 0), 0) +
		Math.max(0, items.length - 1) * 20;
	const time = (s: string) => Number(s.slice(0, 2)) * 60 + Number(s.slice(3));
	let start = 540,
		end = 1260;
	if (day.date === trip.startDate && trip.travelContext?.arrivalTime)
		start = Math.max(start, time(trip.travelContext.arrivalTime));
	if (day.date === trip.endDate && trip.travelContext?.departureTime)
		end = Math.min(end, time(trip.travelContext.departureTime) - 120);
	return {
		minutes,
		unknown,
		remaining: end - start - minutes,
		overloaded: minutes > end - start,
	};
}
